export var AuthWebClientEvents;
(function (AuthWebClientEvents) {
    AuthWebClientEvents["ES_PATIENT_HUB_AUTH_LISTENER"] = "ES_PATIENT_HUB_AUTH_LISTENER";
})(AuthWebClientEvents || (AuthWebClientEvents = {}));
//# sourceMappingURL=auth-web-client-events.enum.js.map